/**
 * @type {import("./config-type").LocaleConfig}
 */
const i18n = {
    defaultLocale: "de",
    locales: ["de", "en"],
};

export { i18n };
